import Login from '@src/pages/Login';
import { ROUTES } from '@src/constants/route';
import Testing from '@src/pages/Testing';
import Receptionist from '@src/pages/Receptionist';
import Product from '@src/containers/Product';
import Order from '@src/pages/Order';
import {
  Category as ProductIcon,
  LocalHospital as TestingIcon,
  GroupAdd as ReceptionistIcon,
  Article as OrderIcon,
  InsertChart as StatisticIcon,
  Settings as SettingsIcon,
  DateRange as DateRangeIcon,
  AdminPanelSettings as AdminPanelSettingsIcon,
} from '@mui/icons-material';
import OrderDetail from '@src/pages/OrderDetail';
import Statistic from '@src/pages/Statistic';
import CustomerDetail from '@src/pages/Customer';
import RetestDate from '@src/containers/RetestDate';
import Setting from '@src/pages/Setting';
import { PERMISSIONS } from '@src/constants';
import Accounts from '@src/pages/Account';

export default [
  {
    name: 'Lễ Tân',
    path: ROUTES.RECEPTIONIST,
    component: Receptionist,
    exact: true,
    restricted: true,
    isPrivate: true,
    icon: ReceptionistIcon,
    sidebar: true,
    permissions: [PERMISSIONS.VIEW_CUSTOMER, PERMISSIONS.MANAGE_CUSTOMER],
  },
  {
    name: 'Khám Bệnh',
    path: ROUTES.TESTING,
    component: Testing,
    exact: true,
    restricted: true,
    isPrivate: true,
    icon: TestingIcon,
    sidebar: true,
    permissions: [PERMISSIONS.TEST_FLOW],
  },
  {
    name: 'login',
    path: ROUTES.LOGIN,
    component: Login,
    exact: true,
    restricted: false,
    isPrivate: false,
  },
  {
    name: 'Sản phẩm',
    path: ROUTES.PRODUCT,
    component: Product,
    exact: true,
    restricted: false,
    isPrivate: true,
    icon: ProductIcon,
    sidebar: true,
    permissions: [PERMISSIONS.VIEW_PRODUCT, PERMISSIONS.MANAGE_PRODUCT],
  },
  {
    name: 'Hóa đơn',
    path: ROUTES.ORDER,
    component: Order,
    exact: true,
    restricted: false,
    isPrivate: true,
    icon: OrderIcon,
    sidebar: true,
    permissions: [PERMISSIONS.VIEW_ORDER],
  },
  {
    name: 'Chi tiết hóa đơn',
    path: ROUTES.ORDER_DETAIL,
    component: OrderDetail,
    exact: true,
    restricted: false,
    isPrivate: true,
    permissions: [PERMISSIONS.VIEW_ORDER],
  },
  {
    name: 'Thống kê',
    path: ROUTES.STATISTIC,
    component: Statistic,
    exact: true,
    icon: StatisticIcon,
    restricted: false,
    isPrivate: true,
    sidebar: true,
    permissions: [PERMISSIONS.VIEW_STATS],
  },
  {
    name: 'Chi tiết khách hàng',
    path: ROUTES.CUSTOMER,
    component: CustomerDetail,
    exact: true,
    restricted: false,
    isPrivate: true,
    permissions: [PERMISSIONS.MANAGE_CUSTOMER, PERMISSIONS.VIEW_CUSTOMER],
  },
  {
    name: 'Lịch tái khám',
    path: ROUTES.RETESTDATE,
    component: RetestDate,
    exact: true,
    icon: DateRangeIcon,
    restricted: false,
    isPrivate: true,
    sidebar: true,
    permissions: [PERMISSIONS.VIEW_RETEST_DATE, PERMISSIONS.MANAGE_RETEST_DATE],
  },
  {
    name: 'Tài khoản',
    path: ROUTES.PERMISSION,
    component: Accounts,
    exact: true,
    icon: AdminPanelSettingsIcon,
    restricted: false,
    isPrivate: true,
    sidebar: true,
    permissions: [PERMISSIONS.VIEW_ACCOUNT, PERMISSIONS.MANAGE_ACCOUNT],
  },
  {
    name: 'Cài đặt',
    path: ROUTES.SETTING,
    component: Setting,
    exact: true,
    icon: SettingsIcon,
    restricted: false,
    isPrivate: true,
    sidebar: true,
  },
];
